import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject, finalize, takeUntil } from 'rxjs';
import { NavigationService } from 'src/app/service/navigation.service';
import { DepartmentSelector } from 'src/app/service/department-selector';
import { DialogService } from 'src/app/service/dialog.service';

@Component({
    selector: 'request-department',
    templateUrl: './request-department.component.html',
    styleUrls: ['./request-department.component.scss'],
})
export class RequestDepartmentComponent implements OnInit, OnDestroy {
    private dead$ = new ReplaySubject<void>();

    constructor(
        private router: Router,
        private navigationService: NavigationService,
        public selector: DepartmentSelector,
        private dialogService: DialogService
    ) {}

    ngOnInit(): void {
        this.navigationService.activity.setupQuickly('Консульское учреждение');
        this.navigationService.activity.loader.show('Инициализация страницы');
        this.selector
            .initialize()
            .pipe(
                finalize(() => this.navigationService.activity.loader.hide()),
                takeUntil(this.dead$)
            )
            .subscribe({
                error: ({ message }) => {
                    this.dialogService.notifyInSnackBar(
                        `Не удалось загрузить список консульских учреждений: ERROR_TEXT: ${message}`,
                        'error'
                    );
                },
            });
    }

    ngOnDestroy(): void {
        this.dead$.next();
        this.dead$.complete();
    }

    get isDepartmentClosed(): boolean {
        return this.selector.selectedDepartment?.closed ?? false;
    }

    isValidDepartment(): boolean {
        return this.selector.selectedDepartment?.country === this.selector.selectedCountry;
    }

    isValid(): boolean {
        return this.selector.selectedDepartment !== null && this.isValidDepartment();
    }

    submit(): void {
        let params = { department: this.selector.selectedDepartment?.code };
        this.router.navigate(['/request-editor'], {
            queryParams: params,
            replaceUrl: true,
        });
    }
}
